/**
 * Use of ECS-based FeatureRollouts have been deprecated as of Jan 2022; do not add
 * any new entries here. New features should instead be added via Control Tower, with
 * an entry in ecsExperiments/types.ts.
 */
export type FeatureRollout =
  | 'AutomaticPersistedQueries'
  | 'CreateGroupWithMIP'
  | 'CreateGroupWithMIPforMSIT'
  | 'CreateGroupCalendarInviteForBroadcast'
  | 'EmbedGroupFeedSortByCreatedAt'
  | 'EmbedShareButton'
  | 'EventsCreation'
  | 'EventsPublisherUIUpdate'
  | 'EventsTimePicker12hrSupport'
  | 'FlightControlPanel'
  | 'GraphqlForcedTracing'
  | 'GroupArchPreview'
  | 'ItemsScopeGroupFiles'
  | 'LiveEventsTeamsPlayer'
  | 'ModeratedQuestionAnswerMVP'
  | 'MobileAppUpsell'
  | 'MobileAppUpsellInLiveEvents'
  | 'NetworkContextUrls'
  | 'NetworkSpecificUrls'
  | 'NotificationLeftPanel'
  | 'NotificationRightOverlayPanel'
  | 'OfficialCommunityNetworkAdmin'
  | 'PeopleSuggestion3S'
  | 'ProxiedImages'
  | 'PublisherWithMobileViewRenderer'
  | 'PushNotifications'
  | 'RealtimeDebugLogging'
  | 'RealtimeDebugPanel'
  | 'RestrictPostingAnyGroup'
  | 'RestrictThreadStarterInEventFeed'
  | 'SearchContentMerge'
  | 'SharePointCuratedConversations'
  | 'SharepointDefaultGroupId'
  | 'SharePointFeedCache'
  | 'SharePointHighlightsWebpart'
  | 'SharePointLinkEmbeddedDocuments'
  | 'SharePointPublisherInCortexTemplate'
  | 'ShouldOpenGroupFilesInNewWindow'
  | 'StorylineFirstRunExperience'
  | 'StorylineHome'
  | 'SuggestedActionIgnoreMaxJoinedGroups'
  | 'SuggestedActionFollowUsersIgnoreCheck'
  | 'TeamsChatButton'
  | 'TeamsQnAAppCaching'
  | 'TeamsQnAModerationTabsThreadCounts'
  | 'TeamsQnAUXUpdates'
  | 'TeamsStreamTokenAuth'

  // FeatureRollouts used for testing the infrastructure - grouping
  // these separately from the regular feature rollouts above. Regular
  // feature rollouts should not have the name 'FeatureRollout' in them.
  | 'FeatureRolloutForTesting1'
  | 'FeatureRolloutForTesting2';

export type FeatureRolloutTreatments = Record<FeatureRollout, boolean>;

export const defaultFeatureRolloutTreatments: FeatureRolloutTreatments = {
  AutomaticPersistedQueries: true,
  CreateGroupWithMIP: false,
  CreateGroupWithMIPforMSIT: false,
  CreateGroupCalendarInviteForBroadcast: false,
  EmbedGroupFeedSortByCreatedAt: false,
  EmbedShareButton: false,
  EventsCreation: false,
  EventsPublisherUIUpdate: false,
  EventsTimePicker12hrSupport: false,
  FeatureRolloutForTesting1: false,
  FeatureRolloutForTesting2: false,
  FlightControlPanel: false,
  GraphqlForcedTracing: false,
  GroupArchPreview: false,
  ItemsScopeGroupFiles: false,
  LiveEventsTeamsPlayer: false,
  ModeratedQuestionAnswerMVP: false,
  MobileAppUpsell: false,
  MobileAppUpsellInLiveEvents: false,
  NetworkContextUrls: false,
  NetworkSpecificUrls: false,
  NotificationLeftPanel: false,
  NotificationRightOverlayPanel: false,
  OfficialCommunityNetworkAdmin: false,
  PeopleSuggestion3S: false,
  ProxiedImages: false,
  PublisherWithMobileViewRenderer: false,
  PushNotifications: false,
  RealtimeDebugLogging: false,
  RealtimeDebugPanel: false,
  RestrictPostingAnyGroup: false,
  RestrictThreadStarterInEventFeed: false,
  SearchContentMerge: false,
  SharePointCuratedConversations: false,
  SharepointDefaultGroupId: false,
  SharePointFeedCache: false,
  SharePointHighlightsWebpart: false,
  SharePointLinkEmbeddedDocuments: false,
  SharePointPublisherInCortexTemplate: false,
  ShouldOpenGroupFilesInNewWindow: false,
  StorylineFirstRunExperience: false,
  StorylineHome: false,
  SuggestedActionIgnoreMaxJoinedGroups: false,
  SuggestedActionFollowUsersIgnoreCheck: false,
  TeamsChatButton: false,
  TeamsQnAAppCaching: false,
  TeamsQnAModerationTabsThreadCounts: false,
  TeamsQnAUXUpdates: false,
  TeamsStreamTokenAuth: false,
};

export type FeatureRolloutIds = Record<FeatureRollout, number | undefined>;

export const featureRolloutIds: FeatureRolloutIds = {
  AutomaticPersistedQueries: 53288,
  CreateGroupWithMIP: 69559,
  CreateGroupWithMIPforMSIT: 69561,
  CreateGroupCalendarInviteForBroadcast: 66612,
  EmbedGroupFeedSortByCreatedAt: 87610,
  EmbedShareButton: 74076,
  EventsCreation: 48139,
  EventsPublisherUIUpdate: 59557,
  EventsTimePicker12hrSupport: 59748,
  FeatureRolloutForTesting1: 42,
  FeatureRolloutForTesting2: undefined,
  FlightControlPanel: 39344,
  GraphqlForcedTracing: 73341,
  GroupArchPreview: undefined,
  ItemsScopeGroupFiles: 77248,
  LiveEventsTeamsPlayer: 89383,
  ModeratedQuestionAnswerMVP: 61785,
  MobileAppUpsell: 61324,
  MobileAppUpsellInLiveEvents: 66101,
  NetworkContextUrls: undefined,
  NetworkSpecificUrls: undefined,
  NotificationLeftPanel: 62675,
  NotificationRightOverlayPanel: 64976,
  OfficialCommunityNetworkAdmin: 87762,
  PeopleSuggestion3S: 72035,
  ProxiedImages: 54900,
  PublisherWithMobileViewRenderer: 59100,
  PushNotifications: 80756,
  RealtimeDebugLogging: 52749,
  RealtimeDebugPanel: 55533,
  RestrictPostingAnyGroup: 85238,
  RestrictThreadStarterInEventFeed: 59809,
  SearchContentMerge: 70404,
  SharePointCuratedConversations: 82470,
  SharepointDefaultGroupId: 90494,
  SharePointFeedCache: 59186,
  SharePointHighlightsWebpart: 67552,
  SharePointLinkEmbeddedDocuments: 66206,
  SharePointPublisherInCortexTemplate: 93638,
  ShouldOpenGroupFilesInNewWindow: 51936,
  StorylineFirstRunExperience: 113526,
  StorylineHome: 1010745,
  SuggestedActionIgnoreMaxJoinedGroups: 82647,
  SuggestedActionFollowUsersIgnoreCheck: undefined,
  TeamsChatButton: 59551,
  TeamsQnAAppCaching: 96761,
  TeamsQnAModerationTabsThreadCounts: 86109,
  TeamsQnAUXUpdates: 1570808,
  TeamsStreamTokenAuth: 54963,
};

export const featureRolloutNames = Object.keys(defaultFeatureRolloutTreatments) as FeatureRollout[];

export interface EcsFeatureRollouts {
  readonly treatments: FeatureRolloutTreatments;
  readonly treatmentsFromService: Partial<FeatureRolloutTreatments>;
  readonly treatmentOverrides: Partial<FeatureRolloutTreatments>;
}
